import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=0284fb64&scoped=true&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284fb64",
  null
  
)

export default component.exports